export default {"src":"/_next/static/media/gif_loader.22669ddf.gif","height":236,"width":482};